import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Form, Input, Button } from "antd";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { associateUser } from "../../utils/api";
import "./UserIdInput.css";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />
);

function UserIdInput({ authStore }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const [userIdCode, setUserIdCode] = useState("");
  const navigate = useNavigate();

  const onFinish = async () => {
    setError("");
    setSubmitting(true);
    try {
      const user = await associateUser(userIdCode);
      authStore.updateUser(user);
      navigate("/");
    } catch (e) {
      console.log(e);
      setError(e.response.data.message);
    }
    setSubmitting(false);
  };

  return (
    <div className="UserIdInput">
      <div className="UserIdInput__wrapper">
        <div className="UserIdInput__container">
          <h4>
            Please specify your user code to link this account to your user.
          </h4>
          <Form
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
            layout="vertical"
            onFinish={onFinish}
          >
            <React.Fragment>
              <Form.Item
                className="UserIdInput__item"
                label="User code"
                name="userIdCode"
                rules={[
                  { required: true, message: "Please enter your user code!" },
                ]}
              >
                <Input onChange={(e) => setUserIdCode(e.target.value)} />
              </Form.Item>
            </React.Fragment>

            {error && <div className="error">{error}</div>}

            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                {submitting && <Spin indicator={antIcon} />}
                {!submitting && <span>Submit</span>}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default observer(UserIdInput);
